<template>

    <div :class="['filter-menu', 'filter-' + name ]">

        <div class="filter-label">
            <!-- {{ label }} -->
        </div>

        <div class="filter-checkbox flex-grow-1 position-relative">

            <div class="custom-control custom-checkbox">
                <input
                    :id="name"
                    type="checkbox"
                    class="custom-control-input"
                    :checked="selected"
                    :disabled="disabled"
                    @click="apply(name, !selected)">
                <label class="custom-control-label" :for="name">{{ label }} </label>
            </div>

        </div>

    </div>

</template>

<script>

import FilterMixin from '@/mls-filter/mixins/FilterMixin.js';
import { startCase } from 'lodash';

export default {

    mixins: [FilterMixin],

    props: {
        options: null,
        selected: Boolean,
    },

    computed: {

    },

    methods: {
        apply(filter, value) {
            this.$store.dispatch('applyFilter', {filter, option: value});
        },
    },
};

</script>

<style lang="scss">



</style>